export const demoApp = () => {
  // const kindAnchors = document.querySelectorAll('nav#kinds a')!;
  // console.log(kindAnchors);
  // kindAnchors.forEach(el => {
  //   el.addEventListener('click', e => {
  //     e.preventDefault();
  //
  //     const target = <HTMLAnchorElement>e.target;
  //     console.log(target.dataset.kind);
  //   });
  // });
};
